import { useState, useEffect } from "react";
import { ventas } from "../../lib/api";
import { formatCurrency } from "../../lib/formato";

// Muestra las líneas de producto de una venta.
//
// El nombre del cliente llega por prop, no de una consulta aparte: quien
// abre el modal ya lo tiene a mano, tanto en la lista de movimientos del
// día como en la ficha del cliente.
const VentaDetailModal = ({ ventaId, cliente, onClose }) => {
  const [detalles, setDetalles] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let vigente = true;
    setCargando(true);
    setError(null);

    ventas
      .detalles(ventaId)
      .then((datos) => {
        if (vigente) setDetalles(Array.isArray(datos) ? datos : []);
      })
      .catch((err) => {
        if (vigente) setError(err.message);
      })
      .finally(() => {
        if (vigente) setCargando(false);
      });

    return () => {
      vigente = false;
    };
  }, [ventaId]);

  const total = detalles.reduce((suma, item) => suma + parseFloat(item.precio_total), 0);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Detalles de la venta</h2>
        {cliente && <p className="modal-subtitulo">{cliente}</p>}

        {cargando ? (
          <p>Cargando...</p>
        ) : error ? (
          <p className="error-message">{error}</p>
        ) : (
          <ul className="venta-detail-list">
            <li className="venta-detail-header">
              <span>Producto</span>
              <span>Cant.</span>
              <span>P/U</span>
              <span>Total</span>
            </li>
            {detalles.map((item) => (
              <li key={item.id}>
                <span className="item-desc">{item.producto_descripcion}</span>
                <span data-label="Cant.">{item.cantidad}</span>
                <span data-label="P/U">{formatCurrency(item.precio_unitario)}</span>
                <span data-label="Total">{formatCurrency(item.precio_total)}</span>
              </li>
            ))}
            <li className="total-row">
              <strong>Total General:</strong>
              <strong>{formatCurrency(total)}</strong>
            </li>
          </ul>
        )}

        <div className="modal-actions">
          <button className="btn-submit" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default VentaDetailModal;
